import Vue from 'vue'
import App from './App'
import I18n from './i18n'
import store from './store'
import router from './router'

Vue.config.productionTip = false
const el = document.getElementById('formulare')
const i18n = new I18n()

if (el) {
  const vm = new Vue({
    el,
    i18n,
    store,
    router,
    components: {
      App
    }
  })

  window.vm = window.vm || vm
}
